import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-defaulttools',
  templateUrl: './defaulttools.component.html',
  styleUrls: [],
})
export class DefaulttoolsComponent {
  ctrlPressed: boolean = false;

  @Input() element;

  @Output()
  editItemEvent = new EventEmitter();

  @Output()
  cloneItemEvent = new EventEmitter();

  @Output()
  deleteItemEvent = new EventEmitter();

  @HostListener('window:keydown.control', ['$event'])
  handleControlKey(event: KeyboardEvent): void {
    if (event) {
      this.ctrlPressed = true;
    }
  }

  @HostListener('window:keyup.control', ['$event'])
  handleControlKeyRelease(event: KeyboardEvent): void {
    if (event) {
      this.ctrlPressed = false;
    }
  }

  editItemClicked(item: any): void {
    item['ctrlPressed'] = this.ctrlPressed;
    this.editItemEvent.emit(item);
  }

  cloneItemClicked(item: any): void {
    item['ctrlPressed'] = this.ctrlPressed;
    this.cloneItemEvent.emit(item);
  }

  deleteItemClicked(item: any): void {
    this.deleteItemEvent.emit(item);
  }
}
